import * as contentful from "contentful";
import CONFIG_CONTENTFUL from "../../config/contentful";

const contentfulClient = contentful.createClient({
	space: CONFIG_CONTENTFUL.SPACE,
	accessToken: CONFIG_CONTENTFUL.ACCESS_TOKEN
});

export const getCoupon = async () =>
	await contentfulClient.getEntry(CONFIG_CONTENTFUL.COUPON_ENTRY_ID);

export const getContent = async () =>
	await contentfulClient.getEntry(CONFIG_CONTENTFUL.CONTENT_ENTRY_ID);

// export const getParking = async id => await contentfulClient.getEntry(id);

export default contentfulClient;
